import classNames from 'clsx';
import React, { type FC } from 'react';
import { blackFriday2024 } from 'reactApp/appHelpers/featuresHelpers/features/blackFriday2024';
import { cyberMonday2025 } from 'reactApp/appHelpers/featuresHelpers/features/cyberMonday2025';
import { enabledExpensivePlanTrial } from 'reactApp/appHelpers/featuresHelpers/features/forceTrial';
import { TariffCardContentSize } from 'reactApp/ui/TariffCardNew/TariffCard.types';

import styles from './TariffLabel.css';
import { type ITariffLabelProps, ETariffLabelKind, ETariffLabelRadius } from './TariffLabel.types';

export const TariffLabel: FC<ITariffLabelProps> = ({
    className,
    internalClassname,
    dataQa,
    children,
    kind = ETariffLabelKind.blue,
    radius = ETariffLabelRadius.r24,
    contentSize = TariffCardContentSize.middle,
    isRebrandingQuotaLanding = false,
    enableTopRightBorder = false,
    subscriptionPage,
    disableAction = false,
    isFromFamilyTariff = false,
    mayPromo2025Enabled = false,
    onClick,
    blackFriday2025Enabled = false,
    isMultiAdvanced,
    marchPromo2026Enabled = false,
}) => (
    <div
        className={classNames(className, {
            [styles.labelClickable]: Boolean(onClick),
            [styles[`labelWrapper_${kind}`]]: !!kind,
        })}
        onClick={onClick}
    >
        <div
            data-qa={dataQa}
            data-qa-kind={dataQa && kind}
            className={classNames(styles.label, internalClassname, {
                [styles[`contentSize_${contentSize}`]]: !!contentSize,
                [styles[`label_${kind}`]]: !!kind,
                [styles[`label_${radius}`]]: !!radius,
                [styles.label_rebrandingQuotaLanding]: isRebrandingQuotaLanding,
                [styles.label_topRightBorder]: enableTopRightBorder,
                [styles.label_blackFriday2024]: !disableAction && blackFriday2024 && !subscriptionPage,
                [styles.label_cyberMonday2025]: !disableAction && cyberMonday2025 && !subscriptionPage,
                [styles.label_family_trial]: enabledExpensivePlanTrial,
                [styles.label_family]: !disableAction && isFromFamilyTariff && !subscriptionPage && !enabledExpensivePlanTrial,
                [styles.label_familyMayPromo2025]: mayPromo2025Enabled,
                [styles.label_advancedBlackFriday2025]: blackFriday2025Enabled && !subscriptionPage && isMultiAdvanced,
                [styles.label_marchPromo2026]: marchPromo2026Enabled,
            })}
        >
            {children}
        </div>
    </div>
);
